import { useState } from 'react';
import { X, BookOpen } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function AuthModal({ open, tab, setTab, onClose }) {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [form,    setForm]    = useState({ name:'', email:'', password:'' });
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handle = async e => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      if (tab === 'login') {
        const data = await login(form.email, form.password);
        onClose();
        if (data.user.role === 'admin') navigate('/admin');
      } else {
        await register(form.name, form.email, form.password);
        onClose();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-blue-900 rounded-lg flex items-center justify-center"><BookOpen size={13} className="text-white"/></div>
            <span className="font-bold text-gray-800">{tab==='login'?'Login to LawOC':'Create Account'}</span>
          </div>
          <button onClick={onClose}><X size={18} className="text-gray-400 hover:text-gray-600"/></button>
        </div>
        <div className="flex gap-1 mb-5 bg-gray-100 rounded-xl p-1">
          {['login','register'].map(t=>(
            <button key={t} onClick={()=>{setTab(t);setError('');setForm({name:'',email:'',password:''});}}
              className={"flex-1 py-2 rounded-lg text-sm font-semibold transition "+(tab===t?'bg-white shadow text-blue-900':'text-gray-500')}>
              {t==='login'?'Login':'Register'}
            </button>
          ))}
        </div>
        <form onSubmit={handle} className="space-y-3">
          {tab==='register'&&(
            <input placeholder="Full name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required
              className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-blue-500"/>
          )}
          <input type="email" placeholder="Email address" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-blue-500"/>
          <input type="password" placeholder={tab==='register'?"Password (min 8 characters)":"Password"} value={form.password} onChange={e=>setForm({...form,password:e.target.value})} required
            className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-blue-500"/>
          {error&&<p className="text-red-500 text-xs bg-red-50 px-3 py-2 rounded-lg">{error}</p>}
          <button type="submit" disabled={loading}
            className="w-full bg-blue-900 text-white py-2.5 rounded-xl text-sm font-semibold hover:bg-blue-800 disabled:opacity-60 transition">
            {loading?'Please wait...':(tab==='login'?'Login':'Create Account')}
          </button>
        </form>
        <p className="text-xs text-center text-gray-400 mt-3">
          {tab==='login'?"Don't have an account? ":"Already have an account? "}
          <button onClick={()=>setTab(tab==='login'?'register':'login')} className="text-blue-600 hover:underline font-medium">
            {tab==='login'?'Register free':'Login'}
          </button>
        </p>
      </div>
    </div>
  );
}
